import { STATES } from "./states";
import { ALL_GAMES } from "./games";

export interface Winner {
  id: string;
  game_id: string;
  state_id: string;
  draw_date: string;
  winner_count: number;
  prize_amount: number;
  games?: any;
  states?: any;
}

// Deterministic per-month winners: ~30 winners spread across states with lotteries.
function rand(seed: string) {
  let h = 5381;
  for (let i = 0; i < seed.length; i++) h = (h * 33) ^ seed.charCodeAt(i);
  return () => {
    h = Math.imul(h ^ (h >>> 13), 0x5bd1e995);
    return ((h ^ (h >>> 15)) >>> 0) / 4294967296;
  };
}

const lotteryStates = STATES.filter((s) => s.has_lottery);
const popularGames = ALL_GAMES.filter((g) => g.is_multistate).slice(0, 3);

export function getWinnersForMonth(year: number, month: number): Winner[] {
  const r = rand(`${year}-${month}`);
  const winners: Winner[] = [];
  for (let i = 0; i < 28; i++) {
    const state = lotteryStates[Math.floor(r() * lotteryStates.length)];
    const game = popularGames[Math.floor(r() * popularGames.length)];
    const day = 1 + Math.floor(r() * 28);
    winners.push({
      id: `w-${year}-${month}-${i}`,
      game_id: game.id,
      state_id: state.id,
      draw_date: `${year}-${String(month).padStart(2, "0")}-${String(day).padStart(2, "0")}`,
      winner_count: 1,
      prize_amount: 1_000_000 + Math.floor(r() * 10_000_000),
      games: { name: game.name, slug: game.slug },
      states: { name: state.name, slug: state.slug, abbreviation: state.abbreviation },
    });
  }
  return winners;
}